import EventEmitter from 'es6-eventemitter';
import ls from 'local-storage';
import Vue from 'vue';
import Router from '../router';

export default class JobsService {

    constructor(http, store){
        this.http = http;
        this.store = store;
        this.events = new EventEmitter();
        this.updateHttpHeaders();
    }

    tryLoginByCode(code){
        return this.http.post('api/login', { code }).then((response) => {
            let {user, token} = response.data;
            this._authorizeUser(user, token);
            this.events.emit('LOGIN');
        }).catch((x) => {
            console.log(x);
            this.logoutWithError(x && x.data && x.data.message ? x.data.message.toString() : "Unknown error");
        });
    }

    renewAuthInfo(){
        return this.http.get('api/me').then(
            (response) => {
                if(!this.store.state.auth.user){
                    this.events.emit('LOGIN');
                }
                this.store.commit('authUser', response.data);
                return response;
            }
        )
    }

    _authorizeUser(user, token){
        this.store.commit('authUser', user);
        this.store.commit('updateJwt', token);
        ls('jwt', token);
        this.updateHttpHeaders();
    }

    logout(){
        this.store.commit('authUserRemove');
        ls.remove('jwt');
        delete this.http.headers.common['Authorization'];
        this.events.emit('LOGOUT');
    }

    updateHttpHeaders(){
        let token = ls('jwt');
        if(token){
            this.http.headers.common['Authorization'] = 'Bearer ' + ls('jwt');
        }
    }

    getJwtToken(){
        return ls.get('jwt');
    }

    logoutWithError(message){
        this.store.commit('authError', message);
        this.logout();
        Router.push('/auth');
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.service.js